/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import './store';
import { namespace } from 'vuex-class';
import {
  Field, Form, Popup, ValidateError,
} from '@hb/finance-ui';
import { Toast, Dialog } from '@hb/coffee';
import {
  Component, Mixins, Prop, Watch,
} from 'vue-property-decorator';

import BioApi from '@/api/bio';
import type { BioAuthVo } from '@/vo/bioAuth';
import IconSvg from '@/components/Icon-svg';
import UbtHelper from '@/shared/tools/ubtHelper';
import IdentityScoreMixins from '@/mixins/finance-identity';
import { setPageTitle } from '@/api/native/utils';
import { Debounce } from '@/shared/decorators/debounce';
import platform from '@/shared/utils/platform';
import { idNoMaskFormart, nameMaskFormat } from '@/shared/utils/dataMaskFormat';
import UserPersonalInfoApi from '@/api/userPersonalInfo';

import { VNode } from 'vue';
import { isH5App } from '@/constant';
import { platformIdentityManager } from '@/shared/identity-verification';
import { validatorPersonName } from '@/shared/utils/validator';
import { trimAll } from '@/shared/utils/trim';
import {
  UploadTypeEnum,
  UploadProcessTypeEnum,
  OCRDataSourceTypeEnum,
  OcrProcessSourceEnum,
  OcrOperationSourceEnum,
} from '@/shared/tools/ocr/enum';
import {
  TE_OCR_ENTER_OLD,
  TC_OCR_FACE,
  TC_OCR_NATIONAL_EMBLEM,
  TC_OCR_TAB,
  TE_OCR_BOTH_SUCCEED,
  TC_OCR_BUTTON_NEXT,
  TQ_OCR_FAIL_POPUP,
} from '@/shared/tools/ocr/tianqi/camera';
import {
  TC_OCR_NOT_CLEAR,
  TE_OCR_SOURCE,
  TE_OCR_NEXT_FRONT_CHECK_SUCCEED,
  TE_OCR_NEXT_FRONT_CHECK_FAILED,
  TE_OCR_NEXT_BASE_CHECK_SUCCEED,
  TE_OCR_NEXT_BASE_CHECK_FAILED,
  ubtButtonNewOcr,
  ubtExposeNewOcr,
} from '@/shared/tools/ocr/tianqi';
import { IS_PRERENDERING } from '@hb/coffee-prerender';
import { agreementService } from '@/service/confirm-agreements';
import { session } from '@/shared/utils/storage';

import style from './index.module.scss';

const BaseInfoIdentityStore = namespace('baseInfoIdentity');

@Component
export default class IdentityMixins extends Mixins(IdentityScoreMixins) {
    $refs!: Dictionary<HTMLElement> & {
        form: Form;
    };

    @Prop(String) readonly pageTitle!: string;

    @Prop(Boolean) readonly isEditAction!: boolean;

    @Prop(Boolean) readonly isCheckIdentityClarityScore!: boolean;

    @Prop(Boolean) readonly entranceType!: string;

    @Prop(Boolean) readonly needEducation!: boolean;

    @Prop(String) readonly productId!: string;

    /** 是否命中ab */
    @Prop(Boolean) readonly hintAbtest!: boolean

    @Prop(Number) readonly processSource!: OcrProcessSourceEnum;

    @Prop(String) readonly operationSource!: OcrOperationSourceEnum;

    @Prop({ type: Boolean, default: false }) readonly ocrAfter!: boolean;

    @Prop({ type: Boolean, default: false }) readonly ocrAfterLoan!: boolean;

    @BaseInfoIdentityStore.State frontIdCard!: string;

    @BaseInfoIdentityStore.State backIdCard!: string;

    @BaseInfoIdentityStore.State defaultUserName!: string;

    @BaseInfoIdentityStore.State shouldMaskUserName!: boolean;

    @BaseInfoIdentityStore.State defaultIdCardNo!: string;

    @BaseInfoIdentityStore.State shouldMaskIdCardNo!: boolean;

    @BaseInfoIdentityStore.State identity!: BioAuthVo.Identity;

    @BaseInfoIdentityStore.State ocrDataType!: OCRDataSourceTypeEnum;

    @BaseInfoIdentityStore.State useCropRatioBackupPlan!: boolean;

    @BaseInfoIdentityStore.State isFront!: boolean;

    @BaseInfoIdentityStore.Getter isFrontOcrSucc!: boolean;

    @BaseInfoIdentityStore.Getter isBackOcrSucc!: boolean;

    @BaseInfoIdentityStore.Getter isOcrSucc!: boolean;

    @BaseInfoIdentityStore.Getter hasIdentityData!: boolean;

    @BaseInfoIdentityStore.Getter useCropRatio!: boolean;

    @BaseInfoIdentityStore.Getter canUseCropRatio!: boolean;

    @BaseInfoIdentityStore.Action $updateState!: (data: Dictionary) => void;

    @BaseInfoIdentityStore.Action getIdentity!: (payload: {
      processSource: OcrProcessSourceEnum,
    }) => Promise<void>;

    @BaseInfoIdentityStore.Action captureIdentity!: (
      paramsData: {
        isFront: boolean,
        onlyCamera: boolean,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        e: { target: { files: unknown[]; value: unknown}; },
        checkOcrReqOptions?: Record<string, unknown>,
        processSource?: OcrProcessSourceEnum,
        operationSource?: OcrOperationSourceEnum,
      }
    ) => Promise<void>;

    @BaseInfoIdentityStore.Action initCropRatioInTangram!: () => Promise<void>;

    // 页面埋点
    protected ubtHelper = new UbtHelper('臻有钱_身份认证');

    // 处理软键盘不回弹，软键盘出现的时候不显示底部按钮
    protected isButtonsVisible = true;

    // 是否显示照片上传失败提示弹窗
    protected showErrDialog = false;

    // 是否显示上传方式切换确认提示弹窗
    protected showUploadCheck = false;

    // 是否显示 身份证查询方式 提示弹窗
    protected isFindCardPopupVisible = false;

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected checkPromiseResolve = () => {};

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected checkPromiseReject = () => {};

    protected showErrDialogTitle: string | null = null;

    protected onShowErrDialogConfirm?: () => void;

    /** 身份证上传失败原因 */
    protected showErrReason: string | null = null;

    /** 初始禁止姓名编辑，避免IOS多次进入OCR后因兼容性问题自动获取焦点唤起了键盘 */
    private disableUserNameEdit = true;

    // h5浏览器
    protected get isBroswerH5() {
      if (platform.isAliMP || platform.isHelloApp) {
        return false;
      }
      return true;
    }

    @Watch('identity', { deep: true })
    protected onIdentity(newValue: BioAuthVo.Identity, oldValue: BioAuthVo.Identity) {
      // 非编辑状态下，ocr 录入成功以后，滚动到底部
      if (!this.isEditAction) {
        // 有 ocr 信息
        if (this.isOcrSucc) {
          // 新的 ocr 信息里面 身份证链接变化，说明用户 ocr 信息有更新
          if (newValue.idCardBackUrl !== oldValue.idCardBackUrl
                    || newValue.idCardFrontUrl !== oldValue.idCardFrontUrl) {
            this.scrollToBottom();
          }
        }
      }
      // 身份证双面识别成功 或 重新上传识别成，触发埋点上报
      if (
        newValue.idCardFrontUrl
        && newValue.idCardBackUrl
        && newValue.idCardBackUrl !== oldValue.idCardBackUrl
        && newValue.idCardFrontUrl !== oldValue.idCardFrontUrl
      ) {
        ubtExposeNewOcr(TE_OCR_BOTH_SUCCEED, {
          uploadType: newValue.uploadType,
          msgSource: session.get('ocrMsgSource'),
          scene: this.processSource,
        });
      }
    }

    // 滚动到底部，依赖  baseInfo 页面 ref = baseInfoRef 加上 css: overflow auto 属性
    protected scrollToBottom() {
      // 需求要求 延迟1秒（1000ms）后上滑
      setTimeout(() => {
        const baseInfoRef = (this.$parent.$refs.baseInfoRef
          || this.$parent.$parent.$refs.myProfile) as HTMLElement;

        if (baseInfoRef && baseInfoRef.scrollTop) {
          baseInfoRef.scrollTop = baseInfoRef.scrollHeight;
        }
      }, 1000);
    }

    // eslint-disable-next-line class-methods-use-this
    protected renderSectionHeader(
      title: VNode | VNode[] | string,
      subTitle?: VNode | VNode[] | string,
    ) {
      return (
            <header class={style.sectionHeader}>
                <div class={style.title}><span class={style.warning}></span>{title}</div>
                {subTitle && <div class={style.subTitle}>{subTitle}</div>}
            </header>
      );
    }


    // 照片模块头部结构
    protected get photoSectionHeader() {
      const title = [
            <span>请上传本人身份证</span>,
            this.isOcrSucc ? (
                <span class={style.succTag}>
                    <IconSvg iconClass="success-check" />
                    <span class={style.succTxt}>识别成功</span>
                </span>
            ) : (
                <span />
            ),
      ];

      return this.renderSectionHeader(title);
    }

    protected get newIdentityProgress() {
      return platformIdentityManager.dispatchNewUserStatus;
    }

    /** 微信小程序无须设置capture="camera"，让用户自行选择拍照或相册 */
    private renderFileInput(isFront: boolean, isRetry: boolean, onlyCamera: boolean) {
      const onChangeEvent = this.onTakePhoto.bind(this, isFront, isRetry, onlyCamera);

      return platform.isWechatMini ? (
        <input type="file" accept="image/*" name="file" class={style.uploadH5} onChange={onChangeEvent} />
      ) : (
        <input type="file" accept="image/*" capture='camera' name="file" class={style.uploadH5} onChange={onChangeEvent} />
      );
    }

    protected renderPhotoItem(isFront: boolean, onlyCamera = false) {
      const photoType = isFront ? '人像面' : '国徽面';
      let idCardUrl = isFront ? this.frontIdCard : this.backIdCard;
      if (this.identity.isTempUploadType) {
        idCardUrl = '';
      }
      // oss 返回的图片是http的 需要将图片 转换成 https ,否则ios Safari浏览器里面不显示
      idCardUrl = idCardUrl.substr(0, 7).toLowerCase() === 'http://' ? idCardUrl.replace('http', 'https') : idCardUrl;
      const buttonStyle = idCardUrl ? style.retryButton : style.captureButton;

      return (
            <div
                class={style.photoItemContainer}
                onClick={
                  this.isBroswerH5 ? () => false
                    : this.onTakePhoto.bind(this, isFront, false, onlyCamera)
                }
            >
                <div
                    class={style.photo}
                >
                    <div
                        class={[style.photoInside, isFront ? style.photoFront : style.photoBack]}
                        style={
                            idCardUrl && {
                              backgroundImage: `url(${idCardUrl})`,
                              filter: 'blur(1px)', // 图片脱敏，高斯模糊
                            }
                        }></div>
                    <span class={buttonStyle}>
                        <span
                          class={[
                            style.icon,
                            this.identity.uploadType === UploadTypeEnum.Camera
                              ? style.camera : style.album,
                          ]}
                        ></span>
                    </span>
                </div>
                <div class={style.photoLabel}>
                    点击上传{photoType}
                </div>
                <span class={style.leftTop} />
                <span class={style.rightTop} />
                <span class={style.leftBottom} />
                <span class={style.rightBottom} />
                {this.isBroswerH5 && this.renderFileInput(isFront, false, onlyCamera)}
            </div>
      );
    }

    protected async created() {
      /** 预渲染模式下，不执行其他操作 */
      if (IS_PRERENDERING) return;

      // 创建的时候 去获取本地存储的值 并更新 state 的值
      const {
        identity,
        defaultUserName,
        defaultIdCardNo,
      } = this.$store.state.baseInfoIdentity;
      // 有缓存（有身份证号，姓名可能存在删除）的场景下
      if (identity.idCardNo) {
        this.$updateState({
          identity,
          defaultUserName: defaultUserName || '',
          // 后端接口中获取到的才做相关的脱敏展示
          shouldMaskUserName: !!defaultUserName,
          defaultIdCardNo: defaultIdCardNo || '',
          shouldMaskIdCardNo: !!defaultIdCardNo,
        });
      }

      // 获取接口返回的值
      await this.getIdentity({ processSource: this.processSource });
      ubtExposeNewOcr(TE_OCR_SOURCE, {
        ocrDataType: this.ocrDataType,
        processType: UploadProcessTypeEnum.CAMERA,
      });

      this.initCropRatioInTangram();
      this.ubtHelper.enterPage({
        // 标记用户的类型
        flagType: 'canUseCropRatio',
        flagValue: String(this.canUseCropRatio),
      });

      if (this.isEditAction) {
        setPageTitle('身份认证');
      }

      // 进入页面 置顶滚动条
      window.scrollTo(0, 1);
    }

    protected mounted() {
      /** 预渲染模式下，不执行其他操作 */
      if (IS_PRERENDERING) return;

      ubtExposeNewOcr(TE_OCR_ENTER_OLD);

      // 非 h5场景 监听，以解决 h5场景 拍照问题 --fix 16325
      if (!isH5App) {
        this.addListener();
      }

      setTimeout(() => {
        this.disableUserNameEdit = false;
      }, 100);
    }

    private addListener() {
      window.addEventListener('keyboard-appear', this.onKeyboardAppear.bind(this));
      window.addEventListener('keyboard-disappear', this.onKeyboardDisppear.bind(this));
    }

    private removeListener() {
      window.removeEventListener('keyboard-appear', this.onKeyboardAppear.bind(this));
      window.removeEventListener('keyboard-disappear', this.onKeyboardDisppear.bind(this));
    }

    protected beforeDestroy() {
      this.ubtHelper.leavePage();

      // fix(FPROJECT-14883)
      if (this.pageTitle) {
        setPageTitle(this.pageTitle);
      }
      this.removeListener();
    }

    // 如果脱敏了则 姓名不需要验证
    protected validateUserName(userName: string): boolean {
      return this.shouldMaskUserName || validatorPersonName(userName);
    }

    protected nameFormat(userName: string): string {
      if (this.shouldMaskUserName) {
        // 需要脱敏的 userName数据 需更新到 state 里面
        this.$updateState({
          identity: {
            ...this.identity,
            userName: nameMaskFormat(userName),
          },
        });
        return nameMaskFormat(userName);
      }
      return trimAll(userName);
    }

    // 身份证号格式化
    protected idNoMaskFormart(idCardNo: string): string {
      if (this.shouldMaskIdCardNo) {
        // 需要脱敏的 idCardNo数据 需更新到 state 里面
        this.$updateState({
          identity: {
            ...this.identity,
            idCardNo: idNoMaskFormart(idCardNo),
          },
        });
        return idNoMaskFormart(idCardNo);
      }
      return idCardNo;
    }

    protected getNormalField(name: keyof BioAuthVo.Identity, label: string, show?: boolean) {
      const fieldProps: Dictionary<Dictionary> = {
        attrs: {
          name,
          label,
          readonly: true,
          value: this.identity[name],
          style: `display:${show === false ? 'none' : 'flex'}`,
        },
        on: {},
      };

      switch (name) {
        case 'userName':
          /** 动态设置姓名表单能否编辑 */
          fieldProps.attrs.readonly = this.disableUserNameEdit;
          fieldProps.attrs.maxLength = 25;
          fieldProps.attrs.rules = [
            { required: true, message: '请填写姓名' },
            {
              validator: this.validateUserName.bind(this),
              message: '姓名只能包含2～25个汉字',
            },
          ];
          fieldProps.on.input = this.onUserNameChange.bind(this);
          fieldProps.attrs.formatter = this.nameFormat.bind(this);
          break;

        case 'periodBegin':
          fieldProps.attrs.value = `${this.getPeriodDate(
            'periodBegin',
          )} - ${this.getPeriodDate('periodEnd')}`;
          break;
        case 'idCardNo':
          fieldProps.attrs.formatter = this.idNoMaskFormart.bind(this);
          break;

        default:
          break;
      }

      return (
            <Field {...fieldProps}>
                {name === 'userName' && (
                    <label slot="input-right" for="userName" class={style.editIcon} />
                )}
            </Field>
      );
    }

    // 照片识别失败显示提示框
    protected renderErrDialog(onlyCamera = false) {
      const defaultFn = () => false;
      const confirmFn = this.onErrDialogConfirm.bind(this);

      return (
        <Popup v-model={this.showErrDialog} contentClass={style.errorDialogV2}>
          <div class={style.dialogTitle}>
            <div class={style.errorTitle}>识别失败！</div>
            <div class={style.errorTips}>{this.showErrReason}</div>
            <div class={style.closeIcon} onClick={this.onErrDialogCancel.bind(this)} />
          </div>
          <div class={style.dialogContent} />
          <div class={style.dialogFooter} onClick={this.isBroswerH5 ? defaultFn : confirmFn}>
            <span class={style.rephotoButton}>
              重新拍摄
              {this.isBroswerH5 && this.renderFileInput(this.isFront, true, onlyCamera)}
            </span>
          </div>
        </Popup>
      );
    }

    // 部分身份证上会写的过期时间是“长期”，后端约定使用4102329600000来表示
    protected getPeriodDate(periodName: 'periodBegin' | 'periodEnd') {
      const periodTime = this.identity[periodName];
      const isLongTerm = String(periodTime) === '4102329600000';

      if (periodTime) {
        return isLongTerm
          ? '长期'
          : new Date(Number(periodTime)).toLocaleDateString().replace(/\//g, '.');
      }

      return '';
    }

    // 用于关键埋点的AB测试属性标记
    protected ubtPageButtonWithCropRatio(buttonName: string) {
      this.$ubtPageButton(
        buttonName,
        'canUseCropRatio',
        String(this.canUseCropRatio),
      );
    }

    /** 切换身份证上传方式确认 */
    protected uploadCheckDialog() {
      const { uploadType } = this.identity;
      return (
        <Popup v-model={this.showUploadCheck} contentClass={[style.uploadCheck, style.errorDialog]}>
          <div class={style.dialogTitle}>
            <div>{uploadType === UploadTypeEnum.Album
              ? '若发起相册上传，已拍摄的身份证信息将清空'
              : '若发起拍摄，已从相册上传的身份证信息将清空'}</div>
          </div>
          <div class={style.dialogFooter}>
            <span
              class={style.cancelButton}
              onClick={this.changeUploadCheck.bind(this, true)}
            >
              {uploadType === UploadTypeEnum.Album ? '发起相册上传' : '发起拍摄'}
            </span>
            <span
              class={style.rephotoButton}
              onClick={this.changeUploadCheck.bind(this, false)}
            >
              再想想
            </span>
          </div>
        </Popup>
      );
    }

    // 上传方式check
    changeUploadCheck(change: boolean) {
      this.showUploadCheck = false;
      if (change) {
        this.$updateState({
          identity: {
            ...this.identity,
            userName: '',
            idCardNo: '',
            periodBegin: '',
            isTempUploadType: !this.identity.isTempUploadType,
          },
          frontIdCard: '',
          backIdCard: '',
        });
        this.checkPromiseResolve();
      } else {
        this.checkPromiseReject();
      }
    }

    // 切换身份证上传方式
    protected changeUploadType(uploadType: UploadTypeEnum) {
      let { isTempUploadType } = this.identity;
      if (!this.frontIdCard && !this.backIdCard) {
        isTempUploadType = true;
      }

      ubtButtonNewOcr(TC_OCR_TAB, { uploadType });
      this.$updateState({
        identity: {
          ...this.identity,
          uploadType,
          isTempUploadType: !isTempUploadType,
        },
      });
    }

    // 上传身份证
    protected async onTakePhoto(
      isFront: boolean,
      isRetry = false,
      onlyCamera = false,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      e: { target: { files: any[]; value: any}; },
    ) {
      const { uploadType, idCardFrontUrl, idCardBackUrl } = this.identity;

      if (this.identity.isTempUploadType) {
        this.showUploadCheck = true;
        await new Promise<void>((resolve, reject) => {
          this.checkPromiseResolve = resolve;
          this.checkPromiseReject = reject;
        });
      }

      if (isFront) {
        ubtButtonNewOcr(TC_OCR_FACE, {
          uploadType,
          // isRetry 为通过「身份证卡片已上传，出现重新上传按钮，点击」重新发起
          isRetry: idCardFrontUrl ? '1' : '0',
        });
      } else {
        ubtButtonNewOcr(TC_OCR_NATIONAL_EMBLEM, {
          uploadType,
          // isRetry 为通过「身份证卡片已上传，出现重新上传按钮，点击」重新发起
          isRetry: idCardBackUrl ? '1' : '0',
        });
      }

      // 只要用户识别失败，后续拍照在支持的情况下都启用备选方案
      if (!this.useCropRatioBackupPlan && isRetry) {
        this.$updateState({
          useCropRatioBackupPlan: true,
        });
      }

      /** h5拍照场景，拍照识别失败，重新拍摄，关闭错误弹窗 */
      if (this.isBroswerH5 && this.showErrDialog) {
        this.onErrDialogReset();
      }

      this.captureIdentity({
        isFront,
        onlyCamera,
        e,
        checkOcrReqOptions: {
          showErrMsg: undefined,
        },
        processSource: this.processSource,
        operationSource: this.operationSource,
      }).catch((error: Dictionary) => {
        // 支付宝小程序各种异常状态处理
        if (error && error.error) {
          const errorCode = Number(error.error);

          switch (errorCode) {
            // 用户取消
            case 11:
              return;

              // 用户未授权拍照权限，客户端app中取消授权不会抛异常
            case 2001:
              Toast('请先允许使用你的摄像头权限');
              return;

            default:
                    //
          }
        } else if (String(error) === '用户不允许授权') { // Android
          Toast('请先允许使用你的摄像头权限');
          return;
        }

        ubtExposeNewOcr(TQ_OCR_FAIL_POPUP, { uploadType });
        this.showErrDialog = true;
        this.showErrReason = (error.message || '') as string;

        this.showErrDialogTitle = `身份证${isFront ? '人像面' : '国徽面'
        }照片不可用，请重新上传`;

        if (error.isCheckOcrError && error.message) {
          this.showErrDialogTitle = error.message ? String(error.message) : null;
        }

        if (!this.isBroswerH5) {
          this.onShowErrDialogConfirm = () => {
            this.onTakePhoto(isFront, true, false, e);
          };
        } else {
          this.$updateState({
            isFront,
          });
        }
      });
    }

    protected onUserNameChange(userName: string) {
      if (this.shouldMaskUserName && userName.length < this.defaultUserName.length) {
        this.$updateState({
          identity: {
            ...this.identity,
            userName: '',
          },
          shouldMaskUserName: false,
        });
      } else {
        this.$updateState({
          identity: {
            ...this.identity,
            userName,
          },
        });
      }

      window.scrollTo(0, Math.max(document.documentElement.scrollTop - 1, 0));

      this.$ubtPageButton(
        '臻有钱_身份认证_姓名',
        '填写栏',
        this.identity.userName,
      );
    }

    protected toastWithExpose(message: string) {
      const { uploadType } = this.identity;

      ubtExposeNewOcr(TE_OCR_NEXT_FRONT_CHECK_FAILED, {
        uploadType,
        processType: UploadProcessTypeEnum.CAMERA,
        errorMessage: message,
      });
      Toast(message);
    }

    @Debounce(200)
    protected async onSubmitButtonClick() {
      const { idCardFrontUrl, idCardBackUrl } = this.identity;
      // 双面识别成功才可提交表单
      if (this.$refs.form && idCardFrontUrl && idCardBackUrl) {
        /** 协议同意完成，提交Ocr表单 */
        if (await agreementService.confirmFinanceAgreements()) {
          (this.$refs.form).submitForm();
        }
      } else {
        const { uploadType } = this.identity;

        this.toastWithExpose(uploadType === UploadTypeEnum.Camera ? '请拍摄身份证' : '请从相册上传身份证');
      }
    }

    /** 是否身份证清晰分不足，清晰分不足则增加埋点 */
    protected isIdentityNotClear() {
      const { uploadType } = this.identity;

      return this.confirmShouldIdentityScore(() => {
        ubtButtonNewOcr(TC_OCR_NOT_CLEAR, {
          uploadType,
          processType: UploadProcessTypeEnum.CAMERA,
        });
      });
    }

    /** 点击下一步按钮，身份证基建校验成功 埋点 */
    protected ubtOcrBaseCheckSucceed() {
      ubtExposeNewOcr(TE_OCR_NEXT_BASE_CHECK_SUCCEED, {
        uploadType: this.identity.uploadType,
        processType: UploadProcessTypeEnum.CAMERA,
        msgSource: session.get('ocrMsgSource'),
        scene: this.processSource,
      });
    }

    protected async onSubmit(errors: ValidateError[]) {
      const { uploadType } = this.identity;
      ubtButtonNewOcr(TC_OCR_BUTTON_NEXT, {
        uploadType,
        canUseCropRatio: String(this.canUseCropRatio),
        msgSource: session.get('ocrMsgSource'),
        scene: this.processSource,
      });

      if (errors.length) {
        this.toastWithExpose(errors[0].message);
        return;
      }

      const { checkOcrNameRes } = await UserPersonalInfoApi.checkUserContact({
        ocrName: this.shouldMaskUserName ? this.defaultUserName : this.identity.userName,
      }) || {};
      if (checkOcrNameRes) {
        this.toastWithExpose('身份证姓名与联系人姓名一致，请返回上一步更新联系人姓名');
        return;
      }

      ubtExposeNewOcr(TE_OCR_NEXT_FRONT_CHECK_SUCCEED, {
        uploadType,
        processType: UploadProcessTypeEnum.CAMERA,
      });

      try {
        await BioApi.uploadIdentity2({
          ...this.identity,
          idCardBackImg: '',
          idCardFrontImg: '',
          idCardBackBase64: '',
          idCardFrontBase64: '',
          userName: this.shouldMaskUserName ? this.defaultUserName : this.identity.userName,
          idCardNo: this.shouldMaskIdCardNo ? this.defaultIdCardNo : this.identity.idCardNo,
          processSource: this.processSource,
          ocrAfter: this.ocrAfter,
          ocrAfterLoan: this.ocrAfterLoan,
        }, platformIdentityManager.dispatchNewUserStatus);

        // 根据不同的类型做埋点验证
        if (!this.hintAbtest) {
          this.ubtPageButtonWithCropRatio('臻有钱_身份认证_下一步');
        } else {
          this.ubtPageButtonWithCropRatio('finance_identity_nextStep');
        }

        /** 请求服务端检验身份证清晰分(此处，仅初始化服务端数据，无弹窗) */
        await this.updatedIdentityScore(OcrProcessSourceEnum.OTHER);

        /**
         * resolveProcessVerify是verifycredit身份证上传成功后的流程处理函数
         */
        if (!this.isEditAction) {
          if (this.isCheckIdentityClarityScore) {
            /** 身份证清晰分检验，不通过展示弹窗，否则完成当前身份证填写 */
            if (this.isIdentityNotClear()) {
              this.ubtOcrBaseCheckSucceed();
              this.$emit('resolveProcessVerify');
            }
          } else {
            this.ubtOcrBaseCheckSucceed();
            this.$emit('resolveProcessVerify');
          }
        } else {
          /** 检验身份证清晰分，若满足则提交，否则中断  */
          if (this.isIdentityNotClear()) {
            this.ubtOcrBaseCheckSucceed();

            this.$emit('resolveProcessVerify');
          }
        }
      } catch (error: any) {
        ubtExposeNewOcr(TE_OCR_NEXT_BASE_CHECK_FAILED, {
          uploadType,
          processType: UploadProcessTypeEnum.CAMERA,
          errorCode: 'code' in error ? error.code : '',
          errorMessage: 'message' in error ? error.message : '',
        });

        // 身份证即将过期
        if (Number(error.code) === 40001) {
          // 清除接口异常Toast，否则Toast会盖在Dialog上面
          Toast.clear();
          Dialog.alert({
            confirmButtonText: '知道了',
            title: '身份证(即将)过期，请更换后重新上传',
            closeable: false,
            zIndex: 3000,
          }).then(() => {
            this.ubtPageButtonWithCropRatio('臻有钱_身份证上传过期');
          });
        }
      }
    }

    // 上一步
    protected onBackStep() {
      this.$ubtPageButton(
        'finance_applypagedoc_documentback',
      );
      this.$emit('cancel');
    }

    protected onErrDialogReset() {
      this.showErrDialog = false;
      this.showErrDialogTitle = null;
      this.onShowErrDialogConfirm = undefined;
    }

    protected onErrDialogConfirm() {
      ubtButtonNewOcr(TQ_OCR_FAIL_POPUP, {
        uploadType: this.identity.uploadType,
        // buttonType：关闭-0 / 重新拍摄-1
        buttonType: '1',
      });

      if (this.onShowErrDialogConfirm) {
        this.onShowErrDialogConfirm();
      }

      this.onErrDialogReset();
    }

    protected onErrDialogCancel() {
      ubtButtonNewOcr(TQ_OCR_FAIL_POPUP, {
        uploadType: this.identity.uploadType,
        // buttonType：关闭-0 / 重新拍摄-1
        buttonType: '0',
      });
      this.onErrDialogReset();
    }

    // 键盘出现
    protected onKeyboardAppear() {
      if (platform.isAndroid || platform.isHarmony) {
        this.isButtonsVisible = false;
      }
    }

    // 键盘回弹
    protected onKeyboardDisppear() {
      this.isButtonsVisible = true;
    }

    // 身份证查询提示弹窗 显示/隐藏
    protected onFindCardPopupShow(show: boolean) {
      this.isFindCardPopupVisible = show;
    }
}
